export const CREATE_DIMENSION_REQUEST = "CREATE_DIMENSION_REQUEST";
export const CREATE_DIMENSION_SUCCESS = "CREATE_DIMENSION_SUCCESS";
export const CREATE_DIMENSION_FAIL = "CREATE_DIMENSION_FAIL";

export const GET_ALL_DIMENSION_REQUEST = "GET_ALL_DIMENSION_REQUEST";
export const GET_ALL_DIMENSION_SUCCESS = "GET_ALL_DIMENSION_SUCCESS";
export const GET_ALL_DIMENSION_FAIL = "GET_ALL_DIMENSION_FAIL";

export const GET_DIMENSION_REQUEST = "GET_DIMENSION_REQUEST";
export const GET_DIMENSION_SUCCESS = "GET_DIMENSION_SUCCESS";
export const GET_DIMENSION_FAIL = "GET_DIMENSION_FAIL";


export const GET_ONE_DIMENSION_REQUEST = "GET_ONE_DIMENSION_REQUEST";
export const GET_ONE_DIMENSION_SUCCESS = "GET_ONE_DIMENSION_SUCCESS";
export const GET_ONE_DIMENSION_FAIL = "GET_ONE_DIMENSION_FAIL";

export const GET_FORM_BUILDER_REQUEST = "GET_FORM_BUILDER_REQUEST";
export const GET_FORM_BUILDER_SUCCESS = "GET_FORM_BUILDER_SUCCESS";
export const GET_FORM_BUILDER_FAIL = "GET_FORM_BUILDER_FAIL";

export const CREATE_FORM_BUILDER_REQUEST = "CREATE_FORM_BUILDER_REQUEST";
export const CREATE_FORM_BUILDER_SUCCESS = "CREATE_FORM_BUILDER_SUCCESS";
export const CREATE_FORM_BUILDER_FAIL = "CREATE_FORM_BUILDER_FAIL";

export const GET_CLIENT_FORM_BUILDER_REQUEST =
  "GET_CLIENT_FORM_BUILDER_REQUEST";
export const GET_CLIENT_FORM_BUILDER_SUCCESS =
  "GET_CLIENT_FORM_BUILDER_SUCCESS";
export const GET_CLIENT_FORM_BUILDER_FAIL = "GET_CLIENT_FORM_BUILDER_FAIL";

export const UPDATE_CLIENT_FORM_BUILDER_REQUEST =
  "UPDATE_CLIENT_FORM_BUILDER_REQUEST";
export const UPDATE_CLIENT_FORM_BUILDER_SUCCESS =
  "UPDATE_CLIENT_FORM_BUILDER_SUCCESS";
export const UPDATE_CLIENT_FORM_BUILDER_FAIL =
  "UPDATE_CLIENT_FORM_BUILDER_FAIL";

export const UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_REQUEST =
  "UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_REQUEST";
export const UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_SUCCESS =
  "UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_SUCCESS";
export const UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_FAIL =
  "UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_FAIL";

export const UPDATE_ONE_DIMENSION_REQUEST = "UPDATE_ONE_DIMENSION_REQUEST";
export const UPDATE_ONE_DIMENSION_SUCCESS = "UPDATE_ONE_DIMENSION_SUCCESS";
export const UPDATE_ONE_DIMENSION_FAIL = "UPDATE_ONE_DIMENSION_FAIL";

export const SET_STATUS_ACTIVE_DIMENSION_REQUEST =
  "SET_STATUS_ACTIVE_DIMENSION_REQUEST";
export const SET_STATUS_ACTIVE_DIMENSION_SUCCESS =
  "SET_STATUS_ACTIVE_DIMENSION_SUCCESS";
export const SET_STATUS_ACTIVE_DIMENSION_FAIL =
  "SET_STATUS_ACTIVE_DIMENSION_FAIL";

export const GET_DIMENSION_PATH_HEIRARCHY_REQUEST =
  "GET_DIMENSION_PATH_HEIRARCHY_REQUEST";
export const GET_DIMENSION_PATH_HEIRARCHY_SUCCESS =
  "GET_DIMENSION_PATH_HEIRARCHY_SUCCESS";
export const GET_DIMENSION_PATH_HEIRARCHY_FAIL =
  "GET_DIMENSION_PATH_HEIRARCHY_FAIL";

export const UPDATE_DIMENSION_PATH_HEIRARCHY_REQUEST =
  "UPDATE_DIMENSION_PATH_HEIRARCHY_REQUEST";
export const UPDATE_DIMENSION_PATH_HEIRARCHY_SUCCESS =
  "UPDATE_DIMENSION_PATH_HEIRARCHY_SUCCESS";
export const UPDATE_DIMENSION_PATH_HEIRARCHY_FAIL =
  "UPDATE_DIMENSION_PATH_HEIRARCHY_FAIL";

export const ASSIGN_MULTIPLE_USERS_TO_DIMENSION_REQUEST =
  "ASSIGN_MULTIPLE_USERS_TO_DIMENSION_REQUEST";
export const ASSIGN_MULTIPLE_USERS_TO_DIMENSION_SUCCESS =
  "ASSIGN_MULTIPLE_USERS_TO_DIMENSION_SUCCESS";
export const ASSIGN_MULTIPLE_USERS_TO_DIMENSION_FAIL =
  "ASSIGN_MULTIPLE_USERS_TO_DIMENSION_FAIL";

export const GET_ALL_USERS_TO_DIMENSION_REQUEST =
  "GET_ALL_USERS_TO_DIMENSION_REQUEST";
export const GET_ALL_USERS_TO_DIMENSION_SUCCESS =
  "GET_ALL_USERS_TO_DIMENSION_SUCCESS";
export const GET_ALL_USERS_TO_DIMENSION_FAIL =
  "GET_ALL_USERS_TO_DIMENSION_FAIL";

export const REMOVE_USER_FROM_DIMENSION_REQUEST =
  "REMOVE_USER_FROM_DIMENSION_REQUEST";
export const REMOVE_USER_FROM_DIMENSION_SUCCESS =
  "REMOVE_USER_FROM_DIMENSION_SUCCESS";
export const REMOVE_USER_FROM_DIMENSION_FAIL =
  "REMOVE_USER_FROM_DIMENSION_FAIL";

export const GET_OVERALL_DIMENSION_HIERARCHY_REQUEST =
  "GET_OVERALL_DIMENSION_HIERARCHY_REQUEST";
export const GET_OVERALL_DIMENSION_HIERARCHY_SUCCESS =
  "GET_OVERALL_DIMENSION_HIERARCHY_SUCCESS";
export const GET_OVERALL_DIMENSION_HIERARCHY_FAIL =
  "GET_OVERALL_DIMENSION_HIERARCHY_FAIL";

export const GET_HIERARCHY_BY_TYPE_REQUEST = "GET_HIERARCHY_BY_TYPE_REQUEST";
export const GET_HIERARCHY_BY_TYPE_SUCCESS = "GET_HIERARCHY_BY_TYPE_SUCCESS";
export const GET_HIERARCHY_BY_TYPE_FAIL = "GET_HIERARCHY_BY_TYPE_FAIL";

export const UPDATE_ENTITY_STATUS_REQUEST = "UPDATE_ENTITY_STATUS_REQUEST";
export const UPDATE_ENTITY_STATUS_SUCCESS = "UPDATE_ENTITY_STATUS_SUCCESS";
export const UPDATE_ENTITY_STATUS_FAIL = "UPDATE_ENTITY_STATUS_FAIL";

export const GET_CUSTOMER_ID_REQUEST = "GET_CUSTOMER_ID_REQUEST";
export const GET_CUSTOMER_ID_SUCCESS = "GET_CUSTOMER_ID_SUCCESS";
export const GET_CUSTOMER_ID_FAIL = "GET_CUSTOMER_ID_FAIL";
